export default __webpack_public_path__ + "static/newlogo-d54717b48779f809ebc0afedf7cbb590.png";